export default __webpack_public_path__ + "static/media/berkley-logo.ad5eeb82.png";